<template>
  <div class="m-0 dbozone-font bg-shikkadood" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-shikkadood">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -shikkadood`">{{ $t('3_5_bonus_20.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_7.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class="font-weight-bold text-sub mt-5" :class="`-${lang} -shikkadood`">{{$t('3_5_bonus_20.paytable.symtable_wild1')}}
            <br>{{$t('3_5_bonus_20.paytable.symtable_wild2')}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-3 align-items-center p-0 d-flex ml-2">
          <span class="font-weight-bold text-sub mt-5" :class="`-${lang} -shikkadood`">{{$t('3_5_bonus_20.paytable.symtable_wild1')}}
            <br>{{$t('3_5_bonus_20.paytable.symtable_scatter')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_6.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[6][3]}}
            <br>{{'4 - ' + paytable[6][2]}}
            <br>{{'3 - ' + paytable[6][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_5.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[5][3]}}
            <br>{{'4 - ' + paytable[5][2]}}
            <br>{{'3 - ' + paytable[5][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[4][3]}}
            <br>{{'4 - ' + paytable[4][2]}}
            <br>{{'3 - ' + paytable[4][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[3][3]}}
            <br>{{'4 - ' + paytable[3][2]}}
            <br>{{'3 - ' + paytable[3][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[2][3]}}
            <br>{{'4 - ' + paytable[2][2]}}
            <br>{{'3 - ' + paytable[2][1]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[1][3]}}
            <br>{{'4 - ' + paytable[1][2]}}
            <br>{{'3 - ' + paytable[1][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/shikkadood/symbol_0.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang} -shikkadood`">{{'5 - ' + paytable[0][3]}}
            <br>{{'4 - ' + paytable[0][2]}}
            <br>{{'3 - ' + paytable[0][1]}}
          </span>
        </div>

        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">

        </div>
      </div>
      <div class="d-flex flex-column nav-shikkadood mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -shikkadood`">{{ $t('3_5_bonus_20.bonus.head') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang} -shikkadood`">{{ $t('3_5_bonus_20.bonus.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang} -shikkadood`">{{ $t('shikkadood.text2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}  -shikkadood`">{{ $t('shikkadood.text3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang} -shikkadood`">{{ $t('shikkadood.text4') }}</span>
      </div>
      <div class="d-flex flex-column nav-shikkadood mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -shikkadood`">{{ $t('3_5_bonus_20.line') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-3">
        <span class="m-0 text-sub" :class="`-shikkadood`">{{ $t('3_5_bonus_20.text-line1') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub" :class="`-shikkadood`">{{ $t('3_5_bonus_20.text-line2') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row mb-5">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/pay/3_5_bonus_20_line.png`)"
          alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-shikkadood',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.content {
  background: #000013;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>